import { createSlice } from "@reduxjs/toolkit";

interface IUiReducer {
  isSiteNavOpen: boolean;
  showSiteNav: boolean;
  addUserEmailModal?: {
    link: string;
    show: boolean;
  };
  userFormError: {
    email: boolean;
    userName: boolean;
    firstName: boolean;
    lastName: boolean;
    wtaSubType: boolean;
    tpaSubType: boolean;
    userType: boolean;
  };
}

const initialState: IUiReducer = {
  isSiteNavOpen: false,
  showSiteNav: true,
  userFormError: {
    email: false,
    userName: false,
    firstName: false,
    lastName: false,
    wtaSubType: false,
    tpaSubType: false,
    userType: false,
  },
};

const sliceUI = createSlice({
  initialState,
  name: "sliceUI",
  reducers: {
    toggleSiteNav(state) {
      state.isSiteNavOpen = !state.isSiteNavOpen;
    },
    openSideNav(state) {
      state.isSiteNavOpen = true;
    },
    closeSideNav(state) {
      state.isSiteNavOpen = false;
    },
    handleShowSiteNav(state) {
      state.showSiteNav = !state.showSiteNav;
    },
    setAddUserEmailModalView(state, action) {
      state.addUserEmailModal = action.payload;
    },
    setUserFormError(state, action) {
      console.log(action);
      state.userFormError = action.payload;
    },
  },
});
export const ReducerUI = sliceUI.reducer;
export const ActionUI = sliceUI.actions;
